export const PERSONAL_TAX_ROUTE = "/personal-tax";

export const PERSONAL_TAX_BLOCKED_APP_ROUTES = [
  "/books",
  "/sales-tax",
  "/mailroom",
  "/community",
];
